/* src/app/shared-module/components/upload-property-images/upload-property-images.component.scss */
ion-content {
  --background:
    linear-gradient(
      
      180deg,
      var(--ion-color-secondary) 0%,
      var(--ion-color-primary-tint) 62%,
      var(--ion-color-secondary-contrast) 100% );
}
.upload-dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px 12px;
  background: var(--ion-color-secondary);
  border-bottom: 1px solid var(--ion-color-light-tint);
}
.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}
.header-icon-box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 14px;
  background: var(--ion-color-primary-tint);
  border: 1px solid var(--ion-color-light-tint);
  flex-shrink: 0;
}
.header-icon-box ion-icon {
  font-size: 22px;
  color: var(--ion-color-secondary-shade);
}
.header-text {
  display: flex;
  flex-direction: column;
}
.header-kicker {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: var(--ion-color-primary);
}
.header-title {
  font-size: 16px;
  font-weight: 700;
  color: var(--ion-color-secondary-shade);
  margin-top: 2px;
}
.header-close-btn {
  --color: var(--ion-color-primary-contrast);
  --background: transparent;
  --box-shadow: none;
  --padding-start: 4px;
  --padding-end: 4px;
}
.header-close-btn ion-icon {
  font-size: 28px;
}
.upload-page {
  padding: 16px 12px 28px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.upload-drop-zone {
  border: 2px dashed var(--ion-color-light-tint);
  border-radius: 22px;
  background: var(--ion-color-secondary);
  padding: 28px 16px;
  cursor: pointer;
  transition: border-color 0.2s ease, background 0.2s ease;
  outline: none;
}
.upload-drop-zone:hover,
.upload-drop-zone:focus,
.upload-drop-zone:active {
  border-color: var(--ion-color-primary);
  background: var(--ion-color-primary-tint);
}
.upload-drop-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}
.upload-drop-icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 20px;
  background: var(--ion-color-primary-tint);
  border: 1px solid var(--ion-color-light-tint);
}
.upload-drop-icon {
  font-size: 34px;
  color: var(--ion-color-secondary-shade);
}
.upload-drop-title {
  font-size: 15px;
  font-weight: 700;
  color: var(--ion-color-secondary-shade);
  text-align: center;
}
.upload-drop-sub {
  font-size: 12px;
  color: var(--ion-color-primary-contrast);
  text-align: center;
}
.upload-browse-btn {
  margin-top: 6px;
  --background: var(--ion-color-secondary-shade);
  --box-shadow: none;
  --border-radius: 12px;
  font-size: 13px;
  font-weight: 500;
  color: #fff;
}
.upload-section {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.upload-section-heading {
  display: flex;
  align-items: center;
  gap: 10px;
}
.section-icon-box-sm {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 13px;
  background: var(--ion-color-primary-tint);
  border: 1px solid var(--ion-color-light-tint);
  flex-shrink: 0;
}
.section-icon-box-sm ion-icon {
  font-size: 20px;
  color: var(--ion-color-secondary-shade);
}
.upload-section-label {
  display: flex;
  flex-direction: column;
}
.upload-section-kicker {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: var(--ion-color-primary);
}
.upload-section-title {
  font-size: 15px;
  font-weight: 700;
  color: var(--ion-color-secondary-shade);
  margin-top: 2px;
}
.upload-badge {
  margin-left: auto;
  min-width: 28px;
  height: 28px;
  padding: 0 8px;
  border-radius: 10px;
  background: var(--ion-color-primary);
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}
.upload-badge-navy {
  background: var(--ion-color-secondary-shade);
}
.upload-surface-card {
  margin: 0;
  width: 100%;
  border-radius: 22px;
  border: 1px solid var(--ion-color-light-tint);
  background: var(--ion-color-secondary);
  box-shadow: 0 14px 26px var(--ion-color-secondary-contrast);
  overflow: hidden;
}
.upload-surface-card ion-card-content {
  padding: 14px 0 14px 14px !important;
  background:
    linear-gradient(
      180deg,
      var(--ion-color-secondary) 0%,
      var(--ion-color-primary-tint) 100%);
}
.upload-swiper {
  width: 100%;
  padding-right: 14px;
  padding-bottom: 26px;
}
.upload-slide {
  display: flex !important;
  height: auto;
  align-items: stretch;
}
.upload-img-wrap {
  position: relative;
  width: 100%;
  border-radius: 16px;
  overflow: hidden;
  background: var(--ion-color-primary-shade);
  border: 1px solid var(--ion-color-light-tint);
  aspect-ratio: 4/3;
}
.upload-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.upload-img-remove {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 10;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: none;
  background: rgba(255, 255, 255, 0.92);
  color: var(--ion-color-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
  transition: background 0.2s ease, transform 0.2s ease;
}
.upload-img-remove ion-icon {
  font-size: 17px;
}
.upload-img-remove:hover,
.upload-img-remove:active {
  background: var(--ion-color-primary);
  color: #fff;
  transform: scale(1.08);
}
.upload-img-remove-danger {
  color: var(--ion-color-danger);
}
.upload-img-remove-danger:hover,
.upload-img-remove-danger:active {
  background: var(--ion-color-danger);
  color: #fff;
}
.upload-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 28px 16px;
}
.upload-empty-icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 18px;
  background: var(--ion-color-primary-tint);
  border: 1px solid var(--ion-color-light-tint);
}
.upload-empty-icon-wrap ion-icon {
  font-size: 26px;
  color: var(--ion-color-primary-contrast);
}
.upload-empty-title {
  display: block;
  font-size: 14px;
  font-weight: 700;
  color: var(--ion-color-secondary-shade);
}
.upload-empty-sub {
  display: block;
  font-size: 12px;
  color: var(--ion-color-primary-contrast);
  text-align: center;
}
.upload-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 12px 16px calc(12px + var(--ion-safe-area-bottom, 0px));
  background: var(--ion-color-secondary);
  border-top: 1px solid var(--ion-color-light-tint);
}
.footer-btn {
  --border-radius: 14px;
  --box-shadow: none;
  font-size: 14px;
  font-weight: 500;
  height: 44px;
}
.footer-btn-upload {
  --background: var(--ion-color-secondary-shade);
  --color: #fff;
}
.footer-btn-cancel {
  --border-color: var(--ion-color-light-tint);
  --color: var(--ion-color-secondary-shade);
}
/*# sourceMappingURL=upload-property-images.component.css.map */
